<script setup lang="ts">
import MultiStepsLogin from "@/components/auth/MultiStepsLogin.vue";
import ComplianceDialog from "@/components/ComplianceDialog.vue";
import { useAuthStore } from "@/stores/authStore";
import { storeToRefs } from "pinia";

const authStore = useAuthStore();
const { showComplianceDialog } = storeToRefs(authStore);

const isTycEnabled = import.meta.env.VITE_TYC_ENABLED === 'true';
</script>

<template>
  <MultiStepsLogin />
  <ComplianceDialog 
    v-if="isTycEnabled && showComplianceDialog" 
    @close="() => authStore.showComplianceDialog = false" 
  />
</template>
